import { render } from "./BasicInputForm.vue?vue&type=template&id=2de184ce&scoped=true&lang=pug"
import script from "./BasicInputForm.vue?vue&type=script&lang=js"
export * from "./BasicInputForm.vue?vue&type=script&lang=js"

import "./BasicInputForm.vue?vue&type=style&index=0&id=2de184ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de184ce"]])

export default __exports__